const data = {
    toursLive: [
        "Stephen Malkmus & Trad Tech 2021/2022 US/Mexico",
        "One Eleven Heavy 2019/2023 US/Europe",
        "Blesst Chest 2013-current US",
        "Street Nights 2011-current US/Europe",
        "The Joggers all 2002-2011",
        "Stephen Malkmus & The Jicks Mirror Traffic/Wig Out At Jagbags/Sparkle Hard US/Eu/Japan/Oz/Nz/SA",
        "Shaky Hands Lunglight and Let It Die Us/Europe 2008-2010",
        "Grails/Silver Apples Tour 2009",
        "Pseudosix US tour 2007",
        "French Kicks Trial of The Century tour 2004",
    ],
    
    discography: [
        "Street Nights: The Long Goodbye (community guidelines) 2024",
        "Street Nights: Human Condition (Friendship) 2020",
        "Blesst Chest: Casual Corner (Friendship) 2018",
        "Stephen Malkmus and The Jicks: Sparkle Hard (Matador) 2018",
        "Blesst Chest: Wish We Were There (Friendship) 2016",
        "Day of The Dead (4AD) 2016",
        "Stephen Malkmus and The Jicks: Wig Out At Jagbags (Matador) 2014",
        "Street Nights: You Have My Word (Friendship) 2013",
        "Stephen Malkmus and The Jicks/LA Guns split (Matador) 2012",
        "Shaky Hands: Let It Die (Kill Rock Stars )2009",
        "Pseudosix s/t  (Partisan )2007",
        "The Joggers :With A Cape And A Cane (Startime/Vagrant)2005",
        "The Joggers: Solid Guild -(startime )2003",
        "The Joggers: s/t (birds) 2002"
    ],
    
    tv: [
        "Stephen Malkmus and The Jicks: The Late Show with David Letterman 2014",
        "Stephen Malkmus and The Jicks: Late Night with Jimmy Fallon 2014",
        "Stephen Malkmus and The Jicks: Late Night with Jimmy Fallon 2011",
        "French Kicks/ Houseband: Last Call with Carson Daly 2004"
    ],
    
};

export default data;
